import { SVGAttributes } from 'react'

export default function AboutUsWave(attributes: SVGAttributes<SVGSVGElement>): JSX.Element {
	return (
		<svg {...attributes} preserveAspectRatio="none" width="2560" height="883" viewBox="0 0 2560 883" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M640 23.0001C640 23.0001 802.5 46.6165 960 46.0001C1120 46.0001 1280 22.9999 1280 22.9999C1280 22.9999 1440 5.53972e-05 1600 7.43868e-05C1760 9.33763e-05 1795.03 14.0179 1920 22.9999C2044.97 31.982 2080 45.9999 2240 45.9999C2400 45.9999 2560 22.9999 2560 22.9999V883H1920H640H0V22.9999C0 22.9999 160 -7.43864e-05 320 1.80436e-10C480 7.43868e-05 640 23.0001 640 23.0001Z" fill="url(#paint0_linear)"/>
			<defs>
				<linearGradient id="paint0_linear" x1="1280" y1="1.80436e-10" x2="1280" y2="883" gradientUnits="userSpaceOnUse">
					<stop stopColor="#8DC63F"/>
					<stop offset=".2" stopColor="#6BAF45"/>
					<stop offset="1" stopColor="#79C2BE" />
				</linearGradient>
			</defs>
		</svg>
	)
}
